module.exports = __webpack_public_path__ + "assets/veritas_slider3.0b78816c.jpg";